const heading2Numbered = [
  "M6.16 15.27l.93-3.48h2.36l-.93 3.48h1.77l.93-3.48h3.25l.46-1.7h-3.26l.62-2.28h3.24L16 6.1h-3.26l.88-3.22h-1.77l-.87 3.22H8.6l.88-3.22H7.71L6.85 6.1H3.59l-.47 1.7h3.26l-.6 2.28H2.52l-.45 1.7h3.26l-.95 3.49zm3.75-5.19H7.55l.6-2.27h2.37z",
  "M.7 4.53V3h1.67v1.54h.7V.81h-.7v1.53H.7V.8H0v3.72zm5.61 0v-.67H4.8l.83-.73c.45-.38.68-.59.68-1.14 0-.3-.08-.6-.29-.84a1.3 1.3 0 0 0-.98-.42c-.34 0-.66.08-.91.3-.31.26-.42.58-.42.95h.72c0-.16.07-.32.18-.43.1-.1.25-.16.42-.16.18 0 .32.06.44.2.08.11.12.26.12.4 0 .15-.09.33-.32.54L3.71 3.92v.6z"
];
export {
  heading2Numbered
};
//# sourceMappingURL=heading2Numbered.js.map
